import { render } from "./OffDutyDetails.vue?vue&type=template&id=08377a6f&scoped=true"
import script from "./OffDutyDetails.vue?vue&type=script&lang=js"
export * from "./OffDutyDetails.vue?vue&type=script&lang=js"

import "./OffDutyDetails.vue?vue&type=style&index=0&id=08377a6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08377a6f"]])

export default __exports__